import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";

import styles from "./MultifactorAuthenticationAdminDeactivationPopup.module.scss";

interface IMultifactorAuthenticationDeactivationPopupProps {
    onCancel: () => void;
    onConfirm: () => void;
}

function MultifactorAuthenticationAdminDeactivationPopup(props: IMultifactorAuthenticationDeactivationPopupProps): JSX.Element {
    const { getText } = useTranslation();

    function renderFooter(): JSX.Element {
        return (
            <div className={styles.footer}>
                <ButtonControl
                    dataCy="password-confirmation-cancel"
                    className="btn btn-default"
                    onClick={() => props.onCancel()}
                    label={getText("CancelLabel")}
                />
                <ButtonControl
                    dataCy="password-confirmation-confirm"
                    variant="brand"
                    label={getText("ConfirmLabel")}
                    onClick={() => props.onConfirm()}
                />
            </div>
        );
    }

    return (
        <Modal
            width={500}
            centerContent
            fixedOverlayPosition
            showOverlay
            disableOverlayClose
            showX
            onClose={() => props.onCancel()}
            title={getText("MultifactorAuthentication_DeactivateMultifactorAuthenticationLabel")}
            footer={renderFooter()}
        >
            <div>
                {getText("MultifactorAuthentication_DeactivateMultifactorAuthenticationAdminMessage")}
            </div>
        </Modal>
    );
}

export { MultifactorAuthenticationAdminDeactivationPopup };
